import { render, staticRenderFns } from "./BookingForm.vue?vue&type=template&id=1d70ac04&scoped=true"
import script from "./BookingForm.vue?vue&type=script&lang=ts"
export * from "./BookingForm.vue?vue&type=script&lang=ts"
import style0 from "./BookingForm.vue?vue&type=style&index=0&id=1d70ac04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d70ac04",
  null
  
)

export default component.exports